import { render, staticRenderFns } from "./CompanyInfoUsers.vue?vue&type=template&id=3198d5ff&"
import script from "./CompanyInfoUsers.vue?vue&type=script&lang=ts&"
export * from "./CompanyInfoUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3198d5ff')) {
      api.createRecord('3198d5ff', component.options)
    } else {
      api.reload('3198d5ff', component.options)
    }
    module.hot.accept("./CompanyInfoUsers.vue?vue&type=template&id=3198d5ff&", function () {
      api.rerender('3198d5ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyInfoUsers.vue"
export default component.exports